import React, { Fragment, useContext } from 'react';
import { HightlightCoefTd, Td } from '~/web-frontend-components/line/outcomes/additional/tables/Td';
import { LineContext } from '~/web-frontend-components/context/AppContexts';
import { insertCoefByType } from '~/web-frontend-core/helpers/calcCoefType/insertCoefByType';
const RowComponent = (props) => {
    const { coefType, appName } = useContext(LineContext);
    return (<Fragment>
         {props.tr
            .map((cell, i, row) => cell.bet && props.getCoef(cell.bet) ?
            <HightlightCoefTd disabled={!!props.disabled} key={`${props.getCoef(cell.bet).odd}_${i}`} highlightChanges={props.highlightChanges} isCoefChoosen={props.isCoefChoosen} style={props.getColumnStyle ? props.getColumnStyle(i, row) : {}} coef={props.getCoef(cell.bet)} onClick={props.onCoefChoose} typeCoef={insertCoefByType(Number(props.getCoef(cell.bet).cf), coefType, appName)} cell={cell}/> :
            <Td key={`${cell.txt || cell.st}_${i}`} style={props.getColumnStyle ? props.getColumnStyle(i, row) : {}} cell={props.decorateCell ? props.decorateCell(cell, i) : cell}/>)}
      </Fragment>);
};
export const Row = React.memo(RowComponent);
const TBodyComponent = (props) => <Fragment>
      {props.rows.map((tr, i) => <tr key={i} className={props.className}>
            {<Row tr={tr} {...props}/>}
         </tr>)}
   </Fragment>;
export const TBody = React.memo(TBodyComponent);



// WEBPACK FOOTER //
// ./src/web-frontend-components/line/outcomes/additional/tables/TBody.jsx